<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-alert show variant="secondary">
          <div v-html="sanitizedText"></div>
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    text: String,
  },
  computed: {
    sanitizedText() {
      return DOMPurify.sanitize(marked(this.text))
    }
  }
}
</script>
